import React from 'react';
import { FlameIcon, DropletIcon, ThermometerIcon, FactoryIcon, MountainIcon, Building2Icon, BriefcaseIcon, WarehouseIcon, HardHatIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { ScrollFadeIn } from './ScrollFadeIn';
const industrialItems = [{
  key: 'facilities.industrial.item1',
  Icon: FlameIcon
}, {
  key: 'facilities.industrial.item2',
  Icon: DropletIcon
}, {
  key: 'facilities.industrial.item3',
  Icon: ThermometerIcon
}, {
  key: 'facilities.industrial.item4',
  Icon: FactoryIcon
}, {
  key: 'facilities.industrial.item5',
  Icon: MountainIcon
}];
const constructionItems = [{
  key: 'facilities.construction.item1',
  Icon: Building2Icon
}, {
  key: 'facilities.construction.item2',
  Icon: BriefcaseIcon
}, {
  key: 'facilities.construction.item3',
  Icon: WarehouseIcon
}, {
  key: 'facilities.construction.item4',
  Icon: HardHatIcon
}];
export function Facilities() {
  const {
    t
  } = useLanguage();
  return <section id="facilities" className="w-full bg-navy py-20 sm:py-28" data-id="element-153">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-154">
        <ScrollFadeIn data-id="element-155">
          <div className="mb-4" data-id="element-156">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-electric" data-id="element-157">
              {t('facilities.label')}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mb-12" data-id="element-158">
            {t('facilities.heading')}
          </h2>
        </ScrollFadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-159">
          {/* Industrial Facilities */}
          <ScrollFadeIn delay={100} data-id="element-160">
            <div className="p-6 bg-graphite border border-slate-700/50 rounded h-full" data-id="element-161">
              <h3 className="text-sm font-bold uppercase tracking-wider text-electric mb-5" data-id="element-162">
                {t('facilities.industrial.title')}
              </h3>
              <ul className="space-y-3" data-id="element-163">
                {industrialItems.map(item => <li key={item.key} className="flex items-center gap-3" data-id="element-164">
                    <div className="shrink-0 w-8 h-8 flex items-center justify-center rounded bg-electric/10" data-id="element-165">
                      <item.Icon className="w-4 h-4 text-electric" data-id="element-166" />
                    </div>
                    <span className="text-sm text-slate-300" data-id="element-167">
                      {t(item.key)}
                    </span>
                  </li>)}
              </ul>
            </div>
          </ScrollFadeIn>

          {/* Construction Facilities */}
          <ScrollFadeIn delay={200} data-id="element-168">
            <div className="p-6 bg-graphite border border-slate-700/50 rounded h-full" data-id="element-169">
              <h3 className="text-sm font-bold uppercase tracking-wider text-electric mb-5" data-id="element-170">
                {t('facilities.construction.title')}
              </h3>
              <ul className="space-y-3" data-id="element-171">
                {constructionItems.map(item => <li key={item.key} className="flex items-center gap-3" data-id="element-172">
                    <div className="shrink-0 w-8 h-8 flex items-center justify-center rounded bg-electric/10" data-id="element-173">
                      <item.Icon className="w-4 h-4 text-electric" data-id="element-174" />
                    </div>
                    <span className="text-sm text-slate-300" data-id="element-175">
                      {t(item.key)}
                    </span>
                  </li>)}
              </ul>
            </div>
          </ScrollFadeIn>
        </div>
      </div>
    </section>;
}